import { getItemsFromCollection } from "directus/src/operations";

export async function fetchHourlyJobConfig({ jobId }) {
  try {
    const query = {
      fields: ["id", "rate", "currency", "billing_frequency", "billing_by_week_day", "billing_by_month_date", "billing_by_month", "budget_margin"],
      filter: {
        job: {
          _eq: jobId,
        },
      },
    };

    const response = await getItemsFromCollection("hourly_job_config", query);
    const item = response[0];
    if (item) {
      if (typeof item.rate === "string") item.rate = Number(item.rate);
      // if (typeof item.billing_frequency === "string") item.billing_frequency = Number(item.billing_frequency);
      if (typeof item.billing_by_week_day === "string") item.billing_by_week_day = Number(item.billing_by_week_day);
      if (typeof item.billing_by_month_date === "string") item.billing_by_month_date = Number(item.billing_by_month_date);
      if (typeof item.billing_by_month === "string") item.billing_by_month = Number(item.billing_by_month);
    }
    return item;
  } catch (error) {
    console.error("Error fetching hourly config:", error);
    throw error;
  }
}
